import { NEWS_ENABLED } from "@/constants/news";
import type { StrapiChart } from "@/types";

export interface DropdownItem {
  id: number;
  label: string;
  href?: string;
  subItems?: DropdownItem[];
}

/** Charts dropdown for header + mobile slideout (matches Strapi order; live price → home). */
export function chartNavDropdownItems(charts: StrapiChart[]): DropdownItem[] {
  return charts.map((c) => ({
    id: c.id,
    label: c.title,
    href: c.slug === "zec-live-price" ? "/" : `/charts/${c.slug}`,
  }));
}

const NEWS_NAV_ITEM: DropdownItem = { id: 9001, label: "News", href: "/news" };
const LEARN_NAV_ITEM: DropdownItem = { id: 9002, label: "Learn", href: "/learn" };

const TOOLS_STATIC_ITEMS: DropdownItem[] = [
  ...(NEWS_ENABLED ? [NEWS_NAV_ITEM] : []),
  LEARN_NAV_ITEM,
];

/** Tools dropdown: Converters (nested), News (when enabled), and Learn. */
export function toolsNavDropdownItems(converters: DropdownItem[]): DropdownItem[] {
  return [
    { id: 9000, label: "Converters", subItems: converters },
    ...TOOLS_STATIC_ITEMS,
  ];
}

export function isNavDropdownItemActive(pathname: string, item: DropdownItem): boolean {
  if (item.href) {
    return item.href === "/"
      ? pathname === "/"
      : pathname === item.href || pathname.startsWith(item.href);
  }
  return item.subItems?.some((sub) => isNavDropdownItemActive(pathname, sub)) ?? false;
}

export interface MenuItem {
  id: number;
  label: string;
  href?: string;
  hasDropdown?: boolean;
  /** Identifies which context-data source to inject as dropdownItems */
  dropdownKey?: "charts" | "tools";
  price?: string;
  dropdownItems?: DropdownItem[];
}

/**
 * Static navigation items.
 * The Charts entry uses `hasDropdown: true` but its dropdownItems are
 * injected at runtime from Strapi data (see Header / NavMenuSidebar).
 */
export const navItems: MenuItem[] = [
  { id: 1, label: "Charts", hasDropdown: true, dropdownKey: "charts", dropdownItems: [] },
  { id: 2, label: "Zcash Chasing Bitcoin", href: "/zcash-chasing-bitcoin" },
  { id: 3, label: "Price History", href: "/price-history" },
  { id: 4, label: "Zcash Halving", href: "/zcash-halving" },
  { id: 5, label: "CYPH Tracker", href: "/cyph-tracker" },
  { id: 6, label: "Tools", hasDropdown: true, dropdownKey: "tools", dropdownItems: [] },
  // { id: 0, label: "ZEC", href: "/", price: "$00.00" },
];
